var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPencil = function SvgPencil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m11.364 3.19 1.446 1.446-1.057 1.058-1.447-1.447 1.058-1.058ZM9.599 4.953 3.83 10.723l-.071 1.21.316.317 1.2-.078 5.77-5.77L9.6 4.953Zm-5.91 8.323 2.027-.132 8.509-8.509-2.861-2.86-8.51 8.508-.12 2.038.954.955Z",
    fill: "currentColor"
  })));
};
export default SvgPencil;